export default async function editUser(user, setUser) {
  const url = (process.env.REACT_APP_API_URL || '') + '/api/user/me';
  const token = localStorage.getItem('token');

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      },
      body: JSON.stringify(user)
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data?.user._id) {
          setUser(data.user);
          resolve();
        } else {
          resolve();
        }
      })
      .catch((err) => {
        resolve();
      });
  });
}
